import { classNames } from "primereact/utils";
import React from "react";

import { onlyDigits } from "../../../common/components/TemplateContainer/InputTemplates";

export const InputCurrency = (props) => {
  const { maxLength } = props;

  const onInput = (e) => {
    const cut = e.target.value;
    const notCut = e.target.value;

    const regex = /^(\d*)\.{0,2}(\d){0,2}$/;

    if (cut.length > maxLength /* 12 */) {
      e.target.value = e.target.value.slice(0, maxLength /* 12 */);
    }
    if (notCut.toString().includes(".")) {
      if (regex.test(notCut)) {
        if (notCut.toString().includes("..")) {
          e.target.value = notCut.substr(0, notCut.length - 1);
        } else {
          if (cut.length < maxLength /* 12 */) {
            const d = notCut.split("");
            const i = d.indexOf(".");
            const asd = notCut.slice(i + 1).length;
            if (asd > 2) {
              e.target.value = notCut.substr(0, notCut.length - 1);
            }
          } else {
            const splitCharter = notCut.split(".");
            if (notCut.length <= maxLength + 3 /* 15 */) {
              const d = notCut.split("");
              const i = d.indexOf(".");
              const asd = notCut.slice(i + 1).length;
              if (asd > 2) {
                e.target.value = notCut.substr(0, notCut.length - 1);
              } else {
                e.target.value = notCut;
              }
            } else {
              if (splitCharter[0].length < maxLength /* 12 */) {
                e.target.value = notCut.slice(0, maxLength + 3 /* 15 */);
              } else {
                if (splitCharter[1].length > 2) {
                  e.target.value = notCut.slice(0, maxLength + 3 /* 15 */);
                } else {
                  e.target.value =
                    notCut.slice(0, maxLength /* 12 */) +
                    notCut.slice(maxLength + 1);
                }
              }
            }
          }
        }
      } else {
        e.target.value = notCut.substr(0, notCut.length - 1);
      }
    }
  };
  const localStringToNumber = (s) => {
    return Number(String(s).replace(/[^0-9.-]+/g, ""));
  };
  const onFocus = (e) => {
    var value = e.target.value;
    e.target.value = value ? localStringToNumber(value) : "";
  };
  const onBlur = (e) => {
    var value = e.target.value === "." ? 0 : e.target.value;
    let formatter = new Intl.NumberFormat(props.locale, {
      style: "currency",
      currency: props.currency, // moneda: USD
      useGrouping: true,
    });

    const formated = formatter.format(value);
    e.target.value = value || value === 0 ? formated : "";
    props.onBlur(e);
  };

  const className = classNames(
    "p-inputtext p-component input-text-react-prime",
    props.className
  );
  return (
    <React.Fragment>
      <input
        className={className}
        type="text"
        disabled={props.disabled}
        onBlur={onBlur}
        onFocus={onFocus}
        style={props.style}
        onInput={onInput}
        onChange={props.onChange}
        placeholder={props.placeholder}
        onKeyPress={onlyDigits}
      ></input>
    </React.Fragment>
  );
};
